import React from 'react';
import '@css/viewer.css'

export default class PdfView extends React.Component {
    constructor() {
        super();

        this.canvasArr = [];
        this.container = '';
        this.pdfDoc = '';
        this.pdfscale = 100;
        this.renderPages = this.renderPages.bind(this);
        this.updatePdf = this.updatePdf.bind(this);
        this.updateScale = this.updateScale.bind(this);
        this.closePdf = this.closePdf.bind(this);
    }

    renderPDF(data) {
        this.container = document.getElementById(this.props.containerID);
        PDFJS.workerSrc = './lib/pdfjs/pdf.worker.min.js';
        PDFJS.getDocument(data).then(function(pdfDoc) {
            this.pdfDoc = pdfDoc;
            this.renderPages();
        }.bind(this));
    }

    renderPages() {
        for (var pageNum = 1; pageNum <= this.pdfDoc.numPages; pageNum++) {
            this.pdfDoc.getPage(pageNum)
                .then(function(page) {
                    //this.pdfscale = 3;//(this.container.clientWidth / page.getViewport(1).width);
                    var viewport = page.getViewport(3);
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    var renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };

                    canvas.height = Math.floor(viewport.height);
                    canvas.width = Math.floor(viewport.width);
                    canvas.style.width = '100%';
                    this.canvasArr.push(canvas);
                    this.container.appendChild(canvas);

                    page.render(renderContext);
                }.bind(this))
        }
    }

    updateScale(increment) {
        if(this.pdfscale + increment > 0) {
            this.pdfscale += increment;
            this.updatePdf();
        }
    }

    updatePdf() {
        this.canvasArr.forEach(function(canvas) {
            canvas.style.width = this.pdfscale + '%';
        }.bind(this));
        /*for (var pageNum = 1; pageNum <= this.pdfDoc.numPages; pageNum++) {
            this.pdfDoc.getPage(pageNum)
                .then(function(page) {
                    var viewport = page.getViewport(this.pdfscale);
                    var canvas = this.canvasArr[page.pageIndex];
                    var ctx = canvas.getContext('2d');
                    var renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    };

                    canvas.height = viewport.height;
                    canvas.width = viewport.width-5;

                    page.render(renderContext);
                }.bind(this))
        }*/
    }

    closePdf() {
        if(this.props.closePdf) {
            this.props.closePdf();
        }
    }

    render() {
        return (
            <div className="viewer-overlay">
                <div className="viewer-toolbar">
                    <i className="fa fa-search-plus fa-lg" onClick={() => this.updateScale(25)}></i>
                    <i className="fa fa-search-minus fa-lg" onClick={() => this.updateScale(-25)}></i>
                    <div className="abs-right inline-block">
                        <i className="fa fa-window-close fa-lg" onClick={this.closePdf}></i>
                    </div>
                </div>
                <div id={this.props.containerID} className='viewer-container'>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.renderPDF({data: atob(this.props.pdfData)});
    }
}


// WEBPACK FOOTER //
// ./src/js/components/PdfView.js